import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { user, signIn, signUp } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState('signin'); // 'signin' | 'signup'
  const [email, setEmail] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    const action = mode === 'signin'
      ? () => signIn(email, password)
      : () => signUp(email, password, displayName);
    const { error , needsVerification } = await action();
    if (error) { setErr(error.message); setLoading(false); return; }
    if (needsVerification) {
      setErr('We sent you a verification email. Please confirm and then log in.');
      setLoading(false);
      return;
    }
    nav('/');
  };

  return (
    <div className="nfig-page flex items-center justify-center">
      <form onSubmit={handleSubmit} className="nfig-panel relative z-10 w-full max-w-md rounded-2xl p-7 sm:p-9">
        <p className="nfig-kicker mb-3">NFig account</p>
        <h1 className="mb-2 text-3xl font-black uppercase">
          {mode === 'signin' ? 'Log in' : 'Create account'}
        </h1>
        <p className="mb-6 text-sm text-slate-400">
          {mode === 'signin' ? 'Welcome back to the collection.' : 'Create your collector profile.'}
        </p>

        {mode === 'signup' && (
          <div className="mb-3">
            <label className="mb-2 block text-xs font-bold uppercase tracking-widest text-slate-300">Display name</label>
            <input
              className="nfig-input"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              required
            />
          </div>
        )}

        <div className="mb-3">
          <label className="mb-2 block text-xs font-bold uppercase tracking-widest text-slate-300">Email</label>
          <input
            type="email"
            className="nfig-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="mb-4">
          <label className="mb-2 block text-xs font-bold uppercase tracking-widest text-slate-300">Password</label>
          <input
            type="password"
            className="nfig-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {err && <p className="mb-3 rounded-lg border border-red-400/20 bg-red-500/10 p-3 text-sm text-red-200">{err}</p>}

        <button
          type="submit"
          disabled={loading}
          className="nfig-button-primary w-full"
        >
          {loading ? 'Please wait…' : (mode === 'signin' ? 'Log in' : 'Sign up')}
        </button>

        <button
          type="button"
          className="mt-4 w-full text-sm text-slate-400 transition hover:text-blue-300"
          onClick={() => setMode(mode === 'signin' ? 'signup' : 'signin')}
        >
          {mode === 'signin' ? "Don't have an account? Sign up" : 'Have an account? Log in'}
        </button>
      </form>
    </div>
  );
}
